// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrandsList_BrandsContainer__8w41w {
  width: calc(64px * 14);
  animation: BrandsList_scroll__YI2rw 20s alternate linear infinite;
}

.BrandsList_BrandsContainer__8w41w:hover {
  animation-play-state: paused;
}

@keyframes BrandsList_scroll__YI2rw {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-64px * 7));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/Welcome/BrandList/BrandsList.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iEAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".BrandsContainer {\n  width: calc(64px * 14);\n  animation: scroll 20s alternate linear infinite;\n}\n\n.BrandsContainer:hover {\n  animation-play-state: paused;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(calc(-64px * 7));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BrandsContainer": `BrandsList_BrandsContainer__8w41w`,
	"scroll": `BrandsList_scroll__YI2rw`
};
export default ___CSS_LOADER_EXPORT___;
